import { Navigate } from "react-router-dom";
import { Button, Card } from "@marekl/adminer/components";
import { BrandLockup } from "../../../components/BrandLockup";
import { SupportContacts } from "../../../components/SupportContacts";
import { useLogout, useMe } from "../../../auth/queries";
import { useMyTeams } from "../../../lib/queries/teams";
import styles from "./PendingApprovalPage.module.css";

export function PendingApprovalPage() {
  const { data: me } = useMe();
  const { data: teams } = useMyTeams();
  const { mutate: logout } = useLogout();

  const pending = (teams ?? []).filter((t) => t.status === "pending");

  // Anyone without pending teams has no business here — send them home.
  if (me && teams !== undefined && pending.length === 0) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <Card.Content>
          <div className={styles.header}>
            <BrandLockup />
            <p className={styles.subtitle}>Čeká na schválení</p>
          </div>
          <p>
            Dobrý den{me?.display_name ? `, ${me.display_name}` : ""}, vaše
            žádost o registraci týmu byla přijata a čeká na schválení
            administrátorem ČNSMS. Po schválení budete mít do systému plný přístup.
          </p>
          {pending.length > 0 && (
            <ul className={styles.list}>
              {pending.map((t) => (
                <li key={t.id}>
                  <strong>{t.name}</strong>: čeká na schválení
                </li>
              ))}
            </ul>
          )}
          <Button block onClick={() => logout()}>
            Odhlásit se
          </Button>
        </Card.Content>
      </Card>
      <SupportContacts />
    </div>
  );
}
